import type { CopyCatalog } from "./copyTypes";

export const IT_COPY: CopyCatalog = {
  "common.loading": "Caricamento…",
  "common.yes": "Sì",
  "common.no": "No",
  "common.notProvided": "Non indicato",
  "common.notRequired": "Non richiesto",
  "common.requested": "Richiesto",
  "nav.back": "Indietro",
  "nav.continue": "Continua",
  "nav.sendRequest": "Invia richiesta",
  "nav.sending": "Invio…",
  "alert.completeFields": "Completare i campi evidenziati prima di continuare.",
  "fill.filled": "Compilato",
  "fill.notFound": "Non trovato",
  "fill.shipmentToo": "Spedizione compilata anche: {detail}",
  "fill.palletMany": "pallet",

  "choose.title": "Come desidera richiedere il preventivo?",
  "choose.manual.title": "Inserimento manuale",
  "choose.manual.description": "Inserisca i dati della spedizione passo dopo passo con il modulo guidato.",
  "choose.manual.action": "Inserire i dati manualmente",
  "choose.quickfill.title": "Quick Fill",
  "choose.quickfill.description":
    "Incolli i dati della spedizione o carichi un documento: compileremo il modulo per lei.",
  "choose.quickfill.action": "Avvia compilazione rapida",

  "steps.route": "Percorso e ordine",
  "steps.shipment": "Spedizione",
  "steps.services": "Servizi aggiuntivi",
  "steps.contact": "Contatto",
  "steps.review": "Verifica",

  "page.route": "Percorso e ordine",
  "page.routeSection": "Percorso",
  "page.shipment": "Dati della spedizione",
  "page.services": "Servizi aggiuntivi",
  "page.contact": "Dati di contatto",
  "page.contactSection": "I suoi dati di contatto",
  "page.review": "Verifica",
  "page.quickFill": "Quick Fill",
  "page.analyzing": "Analisi del documento",

  "route.hintPostcode": "Inserisca un CAP o una città per carico e scarico.",
  "route.hintFullAddress": "Inserisca l’indirizzo completo di carico e scarico.",
  "route.unsupported": "Questo percorso non è supportato. Utilizzi il modulo per {loadCountry} e {unloadCountry}.",
  "route.loading": "Carico",
  "route.unloading": "Scarico",
  "route.origin": "Origine",
  "route.destination": "Destinazione",
  "route.country": "Paese",
  "route.selectCountry": "Selezionare il paese",
  "route.postcode": "CAP",
  "route.postcodePlaceholder": "es. 20100",
  "route.city": "Città",
  "route.cityPlaceholder": "Inserire la città",
  "route.street": "Nome della via",
  "route.streetPlaceholder": "Inserire la via",
  "route.house": "Numero civico",
  "route.housePlaceholder": "es. 12",
  "route.pickupDate": "Data di ritiro preferita:",
  "route.unloadDate": "Data di scarico preferita:",
  "route.datePlaceholder": "gg/mm/aaaa",
  "date.clear": "Cancella data",
  "date.closeCalendar": "Chiudi calendario",
  "date.openCalendar": "Apri calendario",
  "route.specificDateHint":
    "Per merci disponibili in una data specifica. Altrimenti puntiamo all’opzione più rapida.",
  "route.orderDetails": "Dettagli ordine",

  "shipment.goods": "Descrizione delle merci",
  "shipment.goodsPlaceholder": "Cosa desidera trasportare?",
  "shipment.weight": "Peso totale",
  "shipment.qty": "Qtà",
  "shipment.type": "Tipo",
  "shipment.dims": "Dimensioni / LDM",
  "shipment.stackable": "Impilabile",
  "shipment.addRow": "Aggiungi riga di spedizione",
  "shipment.totalLines": "Totale righe: {count}",
  "shipment.selectDims": "Selezionare le dimensioni",
  "shipment.dimsNa": "Dimensioni non applicabili",
  "shipment.sizeModeDims": "L × L × H",
  "shipment.sizeModeLdm": "LDM",
  "shipment.removeRow": "Rimuovi riga di spedizione {n}",
  "shipment.lineLabel": "{text}, riga {n}",
  "shipment.quantity": "Quantità",
  "qty.decrease": "Diminuisci quantità",
  "qty.increase": "Aumenta quantità",
  "shipment.lengthCm": "Lunghezza (cm)",
  "shipment.widthCm": "Larghezza (cm)",
  "shipment.heightCm": "Altezza (cm)",
  "shipment.dimensions": "Dimensioni",
  "shipment.size": "Misura",
  "shipment.ldm": "LDM",

  "pallet.euro": "Euro",
  "pallet.block": "Block",
  "pallet.ibc": "IBC",
  "pallet.cp3": "CP3",
  "pallet.half": "Mezzo pallet",
  "pallet.size80x60": "80×60",
  "pallet.size120x120": "120×120",
  "pallet.size150x80": "150×80",
  "pallet.custom": "Su misura",
  "pallet.unspecified": "LDM",

  "services.aria": "Servizi aggiuntivi",
  "services.pill.adr": "ADR",
  "services.pill.temp": "Temperatura",
  "services.pill.tail": "Sponda idraulica",
  "services.pill.ftl": "FTL",
  "services.pill.time": "Fascia oraria",
  "services.pill.ref": "Riferimento / note",
  "services.pill.references": "Riferimenti",
  "services.pill.attachments": "Allegati aggiuntivi",
  "services.adrClass": "Classe ADR",
  "services.selectClass": "Selezionare la classe",
  "services.unNumber": "Numero ONU",
  "services.unPlaceholder": "es. 1203",
  "services.min": "Min",
  "services.max": "Max",
  "services.tailLoad": "Sponda idraulica al carico",
  "services.tailUnload": "Sponda idraulica allo scarico",
  "services.ftlCopy": "Carico completo richiesto.",
  "services.invoiceRef": "Riferimento fattura",
  "services.reference": "Riferimento",
  "services.loadingRef": "Riferimento di carico",
  "services.unloadingRef": "Riferimento di scarico",
  "services.notes": "Note",
  "services.notesPlaceholder": "es. istruzioni particolari",
  "services.deadline": "Scadenza di consegna preferita:",
  "services.deliveryHint":
    "Per merci da consegnare in una data specifica. Altrimenti puntiamo all’opzione più rapida.",
  "services.loadingTime": "Orario di carico",
  "services.unloadingTime": "Orario di scarico",
  "services.window": "Fascia",
  "services.fixed": "Fisso",
  "services.at": "alle",
  "services.from": "da",
  "services.to": "a",
  "services.timeTypeAria": "Tipo {title}",
  "services.addFiles": "Aggiungi file",
  "services.attachHint":
    "JPEG, PNG, GIF, WebP o PDF. Fino a {maxFiles} file, {maxFileMb} MB ciascuno, {maxTotalMb} MB in totale.",
  "services.adrClass1": "1 Materie esplosive",
  "services.adrClass2": "2 Gas",
  "services.adrClass3": "3 Liquidi infiammabili",
  "services.adrClass4": "4 Materie solide infiammabili",
  "services.adrClass5": "5 Materie comburenti",
  "services.adrClass6": "6 Materie tossiche / infettive",
  "services.adrClass7": "7 Materie radioattive",
  "services.adrClass8": "8 Materie corrosive",
  "services.adrClass9": "9 Materie e oggetti pericolosi diversi",
  "services.summary.adr": "Merci pericolose (ADR)",
  "services.summary.temp": "Temperatura controllata",
  "services.summary.time": "Fasce orarie",
  "services.summary.refNotes": "Riferimento e note",
  "services.summary.tail": "Sponda idraulica",
  "services.summary.ftl": "FTL",
  "services.summary.attachments": "Allegati aggiuntivi",
  "services.tail.loadUnload": "Carico e scarico",
  "services.tail.loadOnly": "Solo carico",
  "services.tail.unloadOnly": "Solo scarico",
  "services.time.load": "Carico: {value}",
  "services.time.unload": "Scarico: {value}",
  "services.time.deadline": "Scadenza: {value}",
  "services.time.fixedSuffix": "{time} (fisso)",
  "services.time.windowRange": "{from} a {until}",
  "services.adr.yes": "Sì",
  "services.adr.classUn": "Classe {class}, ONU {un}",
  "services.adr.classOnly": "Classe {class}",
  "services.adr.unOnly": "ONU {un}",
  "services.temp.range": "{min}°C a {max}°C",
  "services.ref.invoice": "Fattura: {value}",
  "services.ref.loading": "Carico: {value}",
  "services.ref.unloading": "Scarico: {value}",

  "contact.name": "Nome",
  "contact.company": "Azienda",
  "contact.email": "E-mail",
  "contact.phone": "Telefono",
  "contact.comment": "Commento aggiuntivo",
  "contact.privacyBefore":
    "Accetto il trattamento dei miei dati personali in conformità con l’",
  "contact.privacyLink": "informativa sulla privacy",
  "contact.privacyAfter": " di Neele-Vat.",

  "result.thankYou": "Grazie! La richiesta è stata ricevuta.",
  "result.teamWillContact":
    "Il nostro team la contatterà entro 60 minuti durante l’orario d’ufficio.",
  "result.teamWillContactEmail":
    "Il nostro team la contatterà entro 60 minuti durante l’orario d’ufficio all’indirizzo {email}.",
  "result.previewMode": "Modalità anteprima: questa richiesta non è stata realmente inviata.",
  "result.previewFiles": " Nota: i file non possono essere inviati in modalità anteprima.",
  "result.yourReference": "Il suo riferimento",
  "result.copy": "Copia",
  "result.copied": "Copiato",
  "result.nextTitle": "Cosa succede ora",
  "result.next1": "Richiesta ricevuta.",
  "result.next2": "Richiesta in esame.",
  "result.next3": "Risposta entro 60 minuti via e-mail.",
  "result.logged":
    "Abbiamo registrato la richiesta. Se non riceve notizie, ci contatti con i dati sotto indicati.",
  "result.newQuote": "Avvia un nuovo preventivo",
  "result.sendFailed": "Non è stato possibile inviare la richiesta",
  "result.preferDirect": "Preferisce contattarci direttamente?",
  "result.backToEdit": "Torna alla modifica",
  "result.tryAgain": "Riprova",
  "result.hideDetails": "Nascondi dettagli",
  "result.viewSent": "Vedi cosa abbiamo inviato",
  "result.error.rateLimited":
    "Ha effettuato molte richieste in poco tempo. Attenda un momento e riprovi.",
  "result.error.forbidden":
    "Questa richiesta è stata bloccata. Riprovi o ci contatti direttamente.",
  "result.error.network":
    "Non è stato possibile inviare la richiesta in questo momento. Controlli la connessione e riprovi.",
  "result.error.tooLarge":
    "La richiesta è troppo grande. Usi allegati più piccoli o un commento più breve.",
  "result.error.unsupportedType": "Usi solo file JPEG, PNG, GIF, WebP o PDF.",
  "result.error.emailUnavailable":
    "Non è stato possibile inviare la richiesta con gli allegati. Riprovi o ci contatti direttamente.",

  "qf.hint":
    "Incolli un’e-mail o i dati della spedizione, oppure alleghi un’immagine o un PDF. Questo sostituisce i dati già inseriti.",
  "qf.placeholder":
    "es. 24 pallet euro da 3011 Rotterdam a 20095 Amburgo, 12.000 kg, ritiro domani…",
  "qf.ariaPaste": "Dati della spedizione da analizzare",
  "qf.attach": "Allega immagine o PDF",
  "qf.disclaimer":
    "Quanto incolla o allega è usato solo per compilare questa richiesta. Viene elaborato dal servizio di analisi documenti e non viene conservato dopo la compilazione del modulo.",
  "qf.fillForm": "Compila modulo",
  "qf.working": "Elaborazione…",
  "qf.analyzing": "Analisi dei dati…",
  "qf.noFields": "Non è stato possibile riconoscere campi. Aggiunga più dettagli.",
  "qf.rateLimited": "Ha effettuato troppe richieste. Attenda un momento e riprovi.",
  "qf.blocked": "Questa richiesta è stata bloccata. Ci contatti se è inatteso.",
  "qf.extractUnavailable":
    "L’analisi documenti non è disponibile al momento. Incolli invece i dati della spedizione.",
  "qf.genericError": "Si è verificato un errore. Controlli la rete o riprovi.",
  "qf.analyzeTitle": "Analisi del documento...",
  "qf.analyzeSub": "Di solito richiede pochi secondi",
  "qf.analyzeStep1": "Lettura della struttura del documento",
  "qf.analyzeStep2": "Estrazione dei dati di base",
  "qf.analyzeStep3": "Identificazione delle righe di spedizione",
  "qf.removeFile": "Rimuovi {name}",

  "error.loadCountry": "Selezionare un paese di carico.",
  "error.loadPostal": "Inserire il CAP di carico.",
  "error.loadCity": "Inserire la città di carico.",
  "error.loadStreet": "Inserire il nome della via di carico.",
  "error.loadHouseNumber": "Inserire il numero civico di carico.",
  "error.unloadCountry": "Selezionare un paese di scarico.",
  "error.unloadPostal": "Inserire il CAP di scarico.",
  "error.unloadCity": "Inserire la città di scarico.",
  "error.unloadStreet": "Inserire il nome della via di scarico.",
  "error.unloadHouseNumber": "Inserire il numero civico di scarico.",
  "error.pickupDate": "Scegliere una data di ritiro.",
  "error.unloadDate": "Scegliere una data di scarico.",
  "error.invalidDate": "Inserire una data valida.",
  "error.totalWeight": "Inserire il peso totale.",
  "error.goods": "Descrivere le merci.",
  "error.loadCityOrPostal": "Inserire il CAP o la città di carico.",
  "error.unloadCityOrPostal": "Inserire il CAP o la città di scarico.",
  "error.loadPostalInvalid": "Inserire un CAP di carico riconosciuto.",
  "error.loadCityInvalid": "Inserire una città di carico riconosciuta.",
  "error.unloadPostalInvalid": "Inserire un CAP di scarico riconosciuto.",
  "error.unloadCityInvalid": "Inserire una città di scarico riconosciuta.",
  "error.pickupPast": "La data di ritiro non può essere nel passato.",
  "error.unloadPast": "La data di scarico non può essere nel passato.",
  "error.unloadBeforePickup": "La data di scarico non può essere precedente alla data di ritiro.",
  "error.weightRange": "Inserire un peso compreso tra 1 e {max} kg.",
  "error.rangePlain": "{min}–{max}.",
  "error.rangeLdm": "{min}–{max} LDM.",
  "error.rangeCm": "{min}–{max} cm.",
  "error.adrUn": "Inserire il numero ONU a 4 cifre.",
  "error.invoiceRef": "Inserire il riferimento fattura.",
  "error.loadingRef": "Inserire il riferimento di carico.",
  "error.unloadingRef": "Inserire il riferimento di scarico.",
  "error.tempMin": "Inserire la temperatura minima.",
  "error.tempMax": "Inserire la temperatura massima.",
  "error.tempOrder": "Il max deve essere almeno il min.",
  "error.enterNumber": "Inserire un numero.",
  "error.deliveryPast": "La scadenza di consegna non può essere nel passato.",
  "error.deliveryBeforePickup": "La scadenza di consegna non può essere precedente alla data di ritiro.",
  "error.tailSides": "Selezionare carico, scarico o entrambi.",
  "error.attachOne": "Allegare almeno un file.",
  "error.enterTime": "Inserire un orario.",
  "error.enterStartTime": "Inserire un orario di inizio.",
  "error.enterEndTime": "Inserire un orario di fine.",
  "error.enterMinutes": "Inserire i minuti.",
  "error.completeTime": "Inserire un orario completo.",
  "error.enterEmail": "Inserire l’indirizzo e-mail.",
  "error.validEmail": "Inserire un indirizzo e-mail valido.",
  "error.validPhone": "Inserire un numero di telefono valido.",
  "error.personalEmail": "Gli indirizzi e-mail personali non sono accettati.",
  "error.enterName": "Inserire il nome.",
  "error.enterCompany": "Inserire l’azienda.",
  "error.privacy": "Accettare per continuare.",
  "error.quickFillEmpty":
    "Incollare i dati della spedizione o allegare un’immagine o un PDF per compilare il modulo.",
  "error.maxFiles": "È possibile allegare fino a {max} file.",
  "error.maxFileMb": "Ogni file deve essere di {max} MB o inferiore.",
  "error.maxTotalMb": "Gli allegati devono essere di {max} MB o inferiori in totale.",
  "error.filesSkippedType": "Alcuni file sono stati ignorati. Usare JPEG, PNG, GIF, WebP o PDF.",
  "error.emptySkipped": "I file vuoti sono stati ignorati.",
  "error.fileEmpty": "Il file selezionato è vuoto.",
  "error.filesEmptyOrType": "Alcuni file erano vuoti o non erano JPEG, PNG, GIF, WebP o PDF.",
  "error.attachType": "Allegare un JPEG, PNG, GIF, WebP o PDF.",
  "error.subjectLong": "L’oggetto è troppo lungo.",
  "error.emailTextLong": "I dati della richiesta sono troppo lunghi.",
  "error.shortenSubject": "Accorciare questo valore affinché l’oggetto e-mail resti entro {max} caratteri.",
  "error.shortenBody":
    "Accorciare i dati della spedizione o il commento affinché l’e-mail resti entro {max} caratteri.",

  "announce.choose": "Scelga come richiedere il preventivo",
  "announce.quickfill": "Compilazione rapida: incollare i dati o caricare un documento",
  "announce.route": "Passo 1 di 5: percorso e ordine",
  "announce.shipment": "Passo 2 di 5: dati della spedizione",
  "announce.services": "Passo 3 di 5: servizi aggiuntivi",
  "announce.contact": "Passo 4 di 5: dati di contatto",
  "announce.review": "Passo 5 di 5: verifichi la richiesta",
  "announce.received": "Richiesta ricevuta",
  "announce.sendFailed": "Non è stato possibile inviare la richiesta",
  "announce.sendFailedAttempt": "Non è stato possibile inviare la richiesta (tentativo {n})",
  "announce.completeFields": "Completare i campi evidenziati prima di continuare.",
  "announce.sending": "Invio della richiesta…",
};
